import CropAndSaveImageRequest from '../../../../../Spirit/Common/FileManager/Models/CropAndSaveImageRequest';
import InspirationTranslationResponse from '../../../../../Spirit/Admin/Interfaces/Models/InspirationSerivce/InspirationTranslationResponse';

export default class InspirationUpdateRequest  {
	Id?: number = null;
	Back: CropAndSaveImageRequest = null;
	Translations: Array<InspirationTranslationResponse> = null;
	constructor(obj?: Partial<InspirationUpdateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
